<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'BaseOverlayToggle',

  props: {
    name: {
      type: String,
      required: true
    }
  },

  emits: ['click'],

  computed: {
    ...mapState({
      currentOverlay: 'currentOverlay'
    }),

    isOpen () {
      return this.currentOverlay === this.name
    }
  },

  methods: {
    ...mapMutations(['SET_CURRENT_OVERLAY']),

    handleClick () {
      if (this.currentOverlay === this.name) {
        this.close()
      } else {
        this.open()
      }
    },

    open () {
      this.SET_CURRENT_OVERLAY({ name: this.name })
    },

    close () {
      this.SET_CURRENT_OVERLAY({ name: 'none' })
    }
  }
}
</script>

<template>
  <button
    :class="[
      'overlay-toggle t-menu',
      `overlay-toggle--${name}`
    ]"
    @click="handleClick"
  >
    <slot />
  </button>
</template>
